import { createContext,  useEffect, useState } from 'react';
import { Waiter, WaitersResponse, WaiterResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type WaitersContextProps = {
    waiters: Waiter[];
    totalPage: number;
    loadWaiters: (page: number) => Promise<void>;
    addWaiter: ( waiter: Waiter ) => Promise<string>;
    updateWaiter: ( waiter: Waiter ) => Promise<string>;
    deleteWaiter: ( id: number ) => Promise<string>;

}



export const WaitersContext = createContext({} as WaitersContextProps);

export const WaitersProvider = ({ children }: any) => {

    const [waiters, setWaiters] = useState<Waiter[]>([]);    
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    useEffect(() => {
        loadWaiters(0);
    }, [])


    const loadWaiters = async (pageActual) => {

        const resp = await topApi.get<WaitersResponse>('/waiter/getWaiters');
        if(resp.status == 200){
            setWaiters([...resp.data.waiters]);
            setTotalPage(1);
        }


    }

    const addWaiter = async (waiter: Waiter)  => {
        try {
            waiter.id = undefined;
            const resp = await topApi.post<WaiterResponse>('/waiter/', { waiter });
            setWaiters([...waiters, resp.data.waiter]);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }
    

    const updateWaiter = async (waiter:Waiter) => {
        try {
            const resp = await topApi.put<Waiter>(`/waiter/${waiter.id}`, { waiter });
            
                setWaiters(waiters.map(prod => {    
                    return (prod.id === waiter.id)
                        ? resp.data["waiter"]
                        : prod;
                }));
            
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
        
        
    }

    const deleteWaiter = async (id: number) => {
        try {
            await topApi.delete<Waiter>(`/waiter/${id}`);
            setWaiters((prevWaiters) =>
                prevWaiters.filter((waiter) => waiter.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }       
    }

   

    return (
        <WaitersContext.Provider value= {{ waiters, totalPage, loadWaiters, addWaiter, updateWaiter, deleteWaiter}}>
            { children }
        </WaitersContext.Provider>
    );
}